import { FieldTypes } from '../../constants'
import { FieldMap } from '../../types'
import { educationStatusField } from '../education'
import { employmentField } from '../employment'
import { languageField } from '../language'
import { gynPartnerContactField } from '../partner'
import { maidenNameField, patientField } from '../patientField'
import { ethnicityField, raceField } from '../raceEthnicity'
import { addressField } from '../shared'

const placeOfBirthField: FieldMap = {
  name: 'Place of Birth',
  children: {
    state: {
      type: FieldTypes.TEXT,
      placeholder: 'State/Province',
      row: {
        index: 0,
        flex: 1,
      },
    },
    country: {
      type: FieldTypes.TEXT,
      placeholder: 'Country',
      row: {
        index: 0,
        flex: 1,
      },
    },
  },
}

const emergencyContactField: FieldMap = {
  name: 'Emergency Contact',
  children: {
    name: {
      type: FieldTypes.TEXT,
      placeholder: 'Emergency Contact Name',
    },
    phone: {
      type: FieldTypes.PHONE,
      placeholder: 'Emergency Contact Phone',
    },
    relationship: {
      type: FieldTypes.TEXT,
      placeholder: 'Emergency Contact Relationship',
    },
  },
}

const preferredPharmacyField: FieldMap = {
  name: 'Preferred Pharmacy',
  optional: true,
  children: {
    name: {
      type: FieldTypes.TEXT,
      placeholder: 'Pharmacy Name',
      optional: true,
    },
    phone: {
      type: FieldTypes.PHONE,
      placeholder: 'Pharmacy Phone',
      optional: true,
    },
    address: {
      ...addressField,
      condition: v => !!v?.name,
      name: 'Pharmacy Address',
      optional: true,
    },
  },
}

export const gynContactInfoField: FieldMap = {
  name: 'Contact',
  children: {
    patient: {
      ...patientField,
      children: {
        ...patientField.children,
        maidenName: maidenNameField,
        address: addressField,
        placeOfBirth: placeOfBirthField,
        primaryLanguage: { ...languageField, placeholder: 'Primary Language' },
        race: raceField,
        ethnicity: ethnicityField,
        educationStatus: educationStatusField,
        employment: employmentField,
        emergencyContact: emergencyContactField,
        preferredPharmacy: preferredPharmacyField,
      },
    },
    partner: gynPartnerContactField,
  },
}
